<mat-expansion-panel [expanded]="initialExpanded" (opened)="toggleExpanded()" (closed)="toggleExpanded()">
    <mat-expansion-panel-header>
        <mat-panel-title>CONSENT</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="consent-info">
        <ng-container *ngIf="consentData; else listLoading">
            <ng-container *ngIf="consentData.length; else noResults">
                <ng-container *ngFor="let group of consentData">
                    <div class="list-header">
                        {{ group.date | date: 'longDate' }}
                    </div>
                    <mat-list class="full-width">
                        <ng-container *ngFor="let item of group.items">
                            <mat-list-item class="auto-height">
                                <div class="consent-item stack-mobile">
                                    <div class="details">

                                        <div matLine class="consent-title">
                                            <span>{{ item.ConsentForm.label }}</span>
                                        </div>

                                        <div matLine class="consent-status">
                                            <span>Consent Provided:</span>
                                            <mat-icon class="success" *ngIf="item.consentGiven">check</mat-icon>
                                            <mat-icon class="error" *ngIf="!item.consentGiven">close</mat-icon>
                                        </div>

                                        <ng-container
                                            *ngIf="item.consentConditions?.items?.length || item.consentConditions?.bloodTransfusion || item.consentConditions?.procedureSide || item.consentConditions?.selectedImplant">
                                            <h3 class="m-t-10">Consent Responses</h3>
                                            <p
                                                *ngIf="item.consentConditions?.procedureSide || item.consentConditions?.selectedImplant">
                                                <span *ngIf="item.consentConditions?.procedureSide">PROCEDURE SIDE:
                                                    {{item.consentConditions?.procedureSide}}</span>
                                                <span
                                                    *ngIf="item.consentConditions?.procedureSide && item.consentConditions?.selectedImplant">
                                                    | </span>
                                                <span *ngIf="item.consentConditions?.selectedImplant">IMPLANT:
                                                    {{item.consentConditions?.selectedImplant}}</span>
                                            </p>

                                            <div mat-chip class="red-chip truncate-chip"
                                                *ngIf="item.consentConditions.bloodTransfusion == 'NO'" matTooltip="This patient has indicated that they DO NOT consent to a blood transfusion">
                                                NO BLOOD</div>
                                            <ng-container
                                                *ngFor="let response of item.consentConditions?.items; let last = last">
                                                <div mat-chip [matTooltip]="response.text"
                                                    [class.green-chip]="response.category === 'positive'"
                                                    [class.red-chip]="response.category === 'negative'"
                                                    class="truncate-chip">
                                                    {{response.shortText || response.text}}
                                                </div>
                                            </ng-container>
                                        </ng-container>

                                        <app-file-gallery [fileObjects]="item.media"
                                            [deleteEnabled]="false"></app-file-gallery>

                                        <div matLine class="consent-footer">
                                            <div>Requested By: {{ item.requestedBy }} at {{ item.createdAt | date :
                                                'HH:mm'}}</div>
                                            <div *ngIf="item.updatedAt > item.createdAt">
                                                Edited {{ item.updatedAt | dateDiff }} ago
                                            </div>
                                        </div>
                                    </div>
                                    <div class="action-icons">
                                        <button mat-icon-button
                                            *ngIf="!item.consentGiven"
                                            (click)="downloadConsentPDF(item, $event)" 
                                            matTooltip="Download PDF consent form">
                                            <mat-icon>download</mat-icon>
                                        </button>
                                        <button mat-icon-button
                                            *ngIf="!item.consentGiven && latestInvite && patient.email && !stateMode"
                                            (click)="sendConsentEmail(undefined)"
                                            [disabled]="!getResendCooldownState().canResend"
                                            [matTooltip]="getResendCooldownTooltip()">
                                            <mat-icon>send</mat-icon>
                                        </button>
                                        <button mat-icon-button *ngIf="!item.consentGiven && latestInvite && !stateMode"
                                            matTooltip="Open consent invite in a new tab for completion"
                                            (click)="completeConsent($event)">
                                            <mat-icon>open_in_browser</mat-icon>
                                        </button>
                                        <span class="patient-app-state" *ngIf="!item.consentGiven && !stateMode && appState(item).label">{{ appState(item).label }}</span>
                                    </div>
                                </div>
                            </mat-list-item>
                        </ng-container>
                    </mat-list>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</mat-expansion-panel>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No results found.</p>
</ng-template>